import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconNames, Button } from '@dotcom/crown-ui';
import { IconButton } from '../../../../components/icon-button/icon-button';
import styles from '../../select-envelope.module.scss';

export const NavigationButtons = ({
  onClickBack,
  onClickContinue,
  selectedEnvelope,
}: {
  onClickBack: () => void;
  onClickContinue: () => void;
  selectedEnvelope: string;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton
        onClick={onClickBack}
        variant="link"
        testId={'envelope-edit-card-button'}
        className={styles['secondary-action-button']}
        label={t('envelopeSelection.actionButton.back')}
        iconPosition="left"
        iconSize="14"
        iconName={IconNames.ArrowsCaretDown}
      />
      <Button
        onClick={onClickContinue}
        variant="primary"
        testId={'envelope-address-button'}
        className={styles['primary-action-button']}
      >
        {t('envelopeSelection.actionButton.continue')}
      </Button>
    </>
  );
};
